module.exports = __webpack_public_path__ + "static/media/009_A color panel.5dcb83d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/009_A color panel.png
// module id = 376
// module chunks = 0